import React from 'react';
import PropTypes from 'prop-types';
import { ChipField as RAChipField, useRecordContext } from 'react-admin';

const chipSx = {
	borderRadius: '6px',
	textTransform: 'unset',
	backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(158, 158, 158, 0.2)' : '#EBEBEB',
	color: (theme) => theme.palette.mode === 'dark' ? '#bdbdbd' : '#616161'
};

const smallSx = {
	height: '20px'
};

const getChipColors = (color) => {
	switch (color) {
		case 'green':
			return {
				backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(16, 185, 129, 0.2)' : '#d4edda',
				color: (theme) => theme.palette.mode === 'dark' ? '#34d399' : '#155724'
			};
		case 'yellow':
			return {
				backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(251, 191, 36, 0.2)' : '#fff3cd',
				color: (theme) => theme.palette.mode === 'dark' ? '#fbbf24' : '#856404'
			};
		case 'orange':
			return {
				backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 152, 0, 0.2)' : '#fff3e0',
				color: (theme) => theme.palette.mode === 'dark' ? '#ffa726' : '#ef6c00'
			};
		case 'red':
			return {
				backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(232, 107, 107, 0.2)' : '#f8d7da',
				color: (theme) => theme.palette.mode === 'dark' ? '#E86B6B' : '#721c24'
			};
		case 'blue':
			return {
				backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(33, 150, 243, 0.2)' : '#e3f2fd',
				color: (theme) => theme.palette.mode === 'dark' ? '#42a5f5' : '#1565c0'
			};
		default:
			return {
				backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(158, 158, 158, 0.2)' : '#EBEBEB',
				color: (theme) => theme.palette.mode === 'dark' ? '#bdbdbd' : '#616161'
			};
	}
};

const ChipField = ({ source, color = 'default', size = 'small', sx = {}, ...props }) => {
	const record = useRecordContext(props);

	return (
		record && (record[source] !== undefined && record[source] !== null) ?
			<RAChipField sx={{ ...chipSx, ...(size === 'small' ? smallSx : {}), ...sx }} {...{ record, source, size, color, ...props }} />
			: null
	);
};

ChipField.propTypes = {
	source: PropTypes.string.isRequired,
	size: PropTypes.oneOf(["small", "medium"]),
	color: PropTypes.string
};

export default ChipField;
export { getChipColors };